import $ from 'jquery'
import ChartHierarchicalSelectorsSectionStrategy from './ChartHierarchicalSelectorsSectionStrategy'
import {Errors} from './constants'

function BillingHierarchicalSelectorsSectionStrategy({showUserSelector, showIncludeOtherUsersCheckbox, billingUserSelector}) {
    this.params = {
        showUserSelector,
        showIncludeOtherUsersCheckbox,
        billingUserSelector,
    }
}

BillingHierarchicalSelectorsSectionStrategy.prototype = new ChartHierarchicalSelectorsSectionStrategy()

BillingHierarchicalSelectorsSectionStrategy.prototype.updateSectionUI = function() {
    ChartHierarchicalSelectorsSectionStrategy.prototype.updateSectionUI.call(this)
    let classes = this.getVisibleCPSelectorClassName() + " " + this.getVisibleUserSelectorInfoIconClassName()
    classes += this.params.showUserSelector ? " " + this.getVisibleBillingUsersSelectorClassName() : " " + this.getVisibleUsernameClassName()
    classes += this.params.showIncludeOtherUsersCheckbox ? " " + this.getVisibleIncludeOtherUsersCheckboxClassName() : ""

    $(this.container).addClass(classes)
}

BillingHierarchicalSelectorsSectionStrategy.prototype.withUserSelector = function() {
    return this.params.showUserSelector
}

BillingHierarchicalSelectorsSectionStrategy.prototype.getUserSelection = function() {
    return this.params.billingUserSelector.getSelection()
}

BillingHierarchicalSelectorsSectionStrategy.prototype.getSelectedParams = function() {
    return {
        userSelection: this.params.billingUserSelector.getSelection(),
        customersProjectsSelection: this.cpSelector.getCpSelection(),
        includeOtherUsersColumn: this.includeOtherUsersCheckbox.isChecked()
    }
}

BillingHierarchicalSelectorsSectionStrategy.prototype.validate = function() {
    let errors = []

    if (!this.cpSelector.checkSelected())
        errors.push(Errors.ERROR_EMPTY_CP_SELECTION)
    if (!this.validateIsUserSelected())
        errors.push(Errors.ERROR_EMPTY_BILLABLE_USER_SELECTION)

    return errors
}

BillingHierarchicalSelectorsSectionStrategy.prototype.validateIsUserSelected = function() {
    return this.params.billingUserSelector.validateIsUserSelected()
}

BillingHierarchicalSelectorsSectionStrategy.prototype.isShowIncludeOtherUsersCheckbox = function() {
    return this.params.showIncludeOtherUsersCheckbox
}

BillingHierarchicalSelectorsSectionStrategy.prototype.setUserSelection = function(selection) {
    this.params.billingUserSelector.setSelection(selection)
}

export default BillingHierarchicalSelectorsSectionStrategy


// WEBPACK FOOTER //
// ./web/js/reports/charts/BillingHierarchicalSelectorsSectionStrategy.js